/**
 * プレコンサポーター機能のエラー定義
 */

/**
 * ドメインエラーの基底クラス
 */
export class DomainError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'DomainError';
  }
}

/**
 * 学習進捗関連のエラー
 */
export class LearningProgressError extends DomainError {
  constructor(message: string) {
    super(message);
    this.name = 'LearningProgressError';
  }
}

/**
 * テスト関連のエラー
 */
export class ExaminationError extends DomainError {
  constructor(message: string) {
    super(message);
    this.name = 'ExaminationError';
  }
}

/**
 * 修了証関連のエラー
 */
export class CertificateError extends DomainError {
  constructor(message: string) {
    super(message);
    this.name = 'CertificateError';
  }
}

/**
 * 値オブジェクト関連のエラー
 */
export class ValueObjectError extends DomainError {
  constructor(message: string) {
    super(message);
    this.name = 'ValueObjectError';
  }
}
